/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client } from "../client";
import type { MultiTenancyStatusResource, NewTenantResource, ResourceCollection, TagTestResult, TenantMissingVariableResource, TenantResource, TenantVariableResource, GetTenantsOverviewBffResponse, TenantsFilterOptions, GetTenantDetailBffResponse, } from "../resources";
import type { AllArgs, ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";
type TenantListArgs = {
    projectId?: string;
} & ListArgs;
type TenantAllArgs = {
    projectId?: string;
} & AllArgs;
type ListTenantsArgs = {
    projectId?: string;
    tags?: string;
    clonedFromTenantId?: string;
    name?: string;
};
export class TenantRepository extends BasicRepository<TenantResource, NewTenantResource, TenantListArgs, TenantAllArgs> {
    constructor(client: Client) {
        super("Tenants", client);
    }
    status(): Promise<MultiTenancyStatusResource> {
        return this.client.get(this.client.getLink("TenantsStatus"));
    }
    tagTest(tenantIds: string[], tags: string[]): Promise<TagTestResult> {
        return this.client.get(this.client.getLink("TenantTagTest"), { tenantIds, tags });
    }
    getVariables(tenant: TenantResource): Promise<TenantVariableResource> {
        return this.client.get(tenant.Links["Variables"]);
    }
    setVariables(tenant: TenantResource, variables: any): Promise<TenantVariableResource> {
        return this.client.put(tenant.Links["Variables"], variables);
    }
    missingVariables(filterOptions: FilterOptions = {}, includeDetails: boolean = false): Promise<TenantMissingVariableResource[]> {
        const payload = {
            environmentId: filterOptions.environmentId,
            includeDetails: !!includeDetails,
            projectId: filterOptions.projectId,
            tenantId: filterOptions.tenantId,
        };
        return this.client.get(this.client.getLink("TenantsMissingVariables"), payload);
    }
    list(args?: ListTenantsArgs): Promise<ResourceCollection<TenantResource>> {
        return this.client.get(this.client.getLink("Tenants"), { ...args });
    }
    tenantsOverview(pageNumber: number, pageSize: number, filter: TenantsFilterOptions): Promise<GetTenantsOverviewBffResponse> {
        const args = { pageNumber, pageSize, useRealData: true, ...filter };
        return this.client.get("~/bff/spaces/{spaceId}/tenants/overview{?pageNumber,pageSize,filterByName,filterByTags,filterByProject,filterByEnvironment,useRealData}", args);
    }
    tenantDetail(tenantId: string): Promise<GetTenantDetailBffResponse> {
        return this.client.get("~/bff/spaces/{spaceId}/tenants/detail/{tenantId}", { tenantId });
    }
}
type FilterOptions = {
    tenantId?: string;
    projectId?: string;
    environmentId?: string;
};
